/**
 * PurchaseSuccessPage — página tras redirect exitoso de Redsys.
 *
 * Ruta: /entradas/gracias?ref=SH-...
 *
 * Redsys nos manda al cliente aquí tras Ds_MerchantURL_OK. El webhook
 * ya confirmó el pedido en el backend (independiente del navegador),
 * así que aquí solo agradecemos y recordamos que llega email con QR.
 */
import { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Footer from '../components/Footer';

export default function PurchaseSuccessPage() {
  const [params] = useSearchParams();
  const ref = params.get('ref') || '';
  const manual = params.get('manual') === '1';

  useEffect(() => {
    document.title = 'Compra realizada · Pagafácil';
  }, []);

  return (
    <div style={{ fontFamily: '"Hanken Grotesk", system-ui, sans-serif', background: '#F7F2E9', color: '#1E2A2E', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <header style={{ background: '#1E2A2E', color: '#F7F2E9', padding: '18px 24px' }}>
        <Link to="/" style={{ color: 'inherit', textDecoration: 'none', fontFamily: '"Spectral", serif', fontSize: 22, fontWeight: 700 }}>
          pagafácil
        </Link>
      </header>

      <section style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 48 }}>
        <div style={{ maxWidth: 640, textAlign: 'center' }}>
          <div style={{
            width: 88, height: 88, margin: '0 auto 24px',
            borderRadius: '50%', background: '#E8B44A',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 46, color: '#1E2A2E',
          }}>
            ✓
          </div>

          <div style={{ fontFamily: '"Space Mono", monospace', fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', opacity: 0.55 }}>
            {manual ? 'Reserva registrada' : 'Pago recibido'}
          </div>
          <h1 style={{ fontFamily: '"Spectral", serif', fontSize: 56, lineHeight: 1.05, margin: '12px 0 20px' }}>
            {manual ? '¡Gracias! Te contactamos' : '¡Gracias! Ya está'}
          </h1>

          {ref && (
            <div style={{ fontFamily: '"Space Mono", monospace', fontSize: 13, opacity: 0.6, marginBottom: 20 }}>
              Referencia: {ref}
            </div>
          )}

          <p style={{ fontSize: 18, opacity: 0.75, lineHeight: 1.6 }}>
            {manual ? (
              <>Hemos guardado tu reserva. Te escribimos en breve para confirmarte cómo completar el pago.</>
            ) : (
              <>
                Recibirás tus entradas en <b>tu email</b> con un QR nominativo por entrada.
                Si no llega en 5&nbsp;minutos, revisa la carpeta de spam o escríbenos.
              </>
            )}
          </p>

          <div style={{ marginTop: 40, display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/entradas" style={btnGold}>Ver más eventos →</Link>
            <Link to="/" style={btnGhost}>Inicio</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

const btnGold: React.CSSProperties = {
  background: '#E8B44A',
  color: '#1E2A2E',
  padding: '14px 28px',
  borderRadius: 12,
  textDecoration: 'none',
  fontWeight: 700,
  fontFamily: '"Hanken Grotesk", sans-serif',
};
const btnGhost: React.CSSProperties = {
  background: 'transparent',
  color: '#1E2A2E',
  padding: '14px 28px',
  borderRadius: 12,
  textDecoration: 'none',
  fontWeight: 600,
  border: '1px solid #1E2A2E',
};
